import { Component } from '@angular/core';

@Component({
  selector: 'sharendipity-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  constructor() {}
}
